import { EImportacaoType } from "../components/table/EImportacaoType";
import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { ILoteDetalhes } from "../dto/ILoteDetalhes";
import { Subscription } from "rxjs";
import { HttpParams } from "@angular/common/http";
import { HttpService } from "../../services/http/http-client.service";
import { NotificationsService } from "angular2-notifications";
import { EStatusLoteEnum } from "../enums/EStatusLoteEnum";
import { ITableProps } from "../components/table/ITableProps";
import { downloadErrorReport } from "../utils/download-error-report";
import { OrigemImportacaoService } from "../utils/origem-importacao.service";

@Component({ template: "" })
export abstract class ImportarArquivoBaseComponent
  implements OnInit, OnDestroy
{
  public urlGet = "";
  public loteId: number = null;
  public loteDetalhes: ILoteDetalhes = null;
  public showTableProcessing: boolean = false;
  public showTableErrors: boolean = false;
  public showActionButtons: boolean = true;
  public filters: HttpParams = new HttpParams();
  public breadcrumbPath: { label: string; link?: string }[];
  public customLogin;
  public emitirCartao: string;

  private intervalId: any;
  private subscriptions: Subscription = new Subscription();

  public abstract EImportacaoType: EImportacaoType;
  public abstract urlPost: string;
  public abstract errorTableColumns: Array<ITableProps>;

  constructor(
    public http: HttpService,
    public notifications: NotificationsService,
    public activatedRoute: ActivatedRoute,
    private origemService: OrigemImportacaoService
  ) {}

  ngOnInit(): void {
    const resCustom = localStorage.getItem("bway-customLogin");
    this.customLogin = JSON.parse(resCustom);

    this.emitirCartao = this.origemService.getEmitirCartao(
      this.origemService.getOrigemImportacao()
    );

    this.activatedRoute.queryParamMap.subscribe((params: any) => {
      this.loteId = params.params.loteId;
      if (this.loteId) {
        this.setUrlGet();
        this.getDados();
      }
    });

    this.setBreadcrumbPath();
  }

  ngOnDestroy(): void {
    this.destroyRefreshInterval();
  }

  abstract setBreadcrumbPath(): void;
  abstract setUrlGet(): void;
  abstract getDados(): void;
  abstract goToFinished(): void;
  abstract handleImportSuccess(event): void;
  abstract continue(): void;
  abstract cancel(): void;
  abstract downloadErrorReport(): void;

  downloadErrorReportCall<T>(importacaoType: EImportacaoType) {
    downloadErrorReport<T>(this.http, this.loteId, importacaoType);
  }

  createRefreshInterval(): void {
    if (!this.intervalId) {
      this.intervalId = setInterval(() => {
        if (!this.showTableErrors && this.loteId) {
          this.getDados();
        }
      }, 10000);
    }
  }

  destroyRefreshInterval() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
      this.intervalId = null;
    }

    if (this.subscriptions && !this.subscriptions.closed) {
      this.subscriptions.unsubscribe();
    }
  }

  validateData(lote: ILoteDetalhes) {
    if (lote) {
      const statusLote = EStatusLoteEnum[lote.status];
      if (
        statusLote === EStatusLoteEnum.ERRO ||
        (statusLote === EStatusLoteEnum.ABERTO && lote.qtdErros > 0)
      ) {
        this.validateError(lote);
        return;
      }

      switch (statusLote) {
        case EStatusLoteEnum.CRIADO:
        case EStatusLoteEnum.EM_VALIDACAO:
          this.validateProcessing();
          break;
        case EStatusLoteEnum.ABERTO:
          this.continue();
          break;
        case EStatusLoteEnum.AGUARDANDO_PROCESSAMENTO:
        case EStatusLoteEnum.EM_PROCESSAMENTO:
        case EStatusLoteEnum.FINALIZADO:
        case EStatusLoteEnum.CANCELADO:
          this.goToFinished();
          break;
        case EStatusLoteEnum.ERRO:
          this.validateError(lote);
          break;
        default:
          this.continue();
          break;
      }
    }
  }

  validateProcessing() {
    this.createRefreshInterval();
    this.showTableProcessing = true;
    this.showTableErrors = false;
    this.showActionButtons = false;
  }

  validateError(lote: ILoteDetalhes) {
    this.destroyRefreshInterval();
    this.filters = this.filters.append("status", "ERRO");
    this.showTableProcessing = false;
    this.showTableErrors = true;
    this.showActionButtons = lote.totalRegistros > lote.qtdErros;
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }
}
